// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"p_-z"};